// import dayjs from "dayjs";
// import "./Transactions.css";

// import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import NotesOutlinedIcon from "@mui/icons-material/NotesOutlined";
// import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";

// const money = (n) => Number(n || 0).toLocaleString();

// export default function TransactionCard({ tx, onEdit, onDelete }) {
//   const isPartial = tx.paymentType === "partial";
//   const typeClass = isPartial ? "txType txType--partial" : "txType txType--full";
//   const note = tx.remarks || tx.description || "No notes";

//   return (
//     <div className="txCard">
//       <div className="txCardBody">
//         <div className="txTop">
//           <div className="txBadge">
//             <PaidOutlinedIcon style={{ fontSize: 18 }} />
//           </div>

//           <div style={{ minWidth: 0 }}>
//             <div className="txTitle2" title={tx.title}>{tx.title}</div>
//             <div className="txReceiver" title={tx.receiverName}>{tx.receiverName}</div>
//           </div>

//           <div className={typeClass}>{isPartial ? "Partial" : "Full"}</div>
//         </div>

//         <div className="txMid">
//           <div className="kv">
//             <small>Date</small>
//             <b>{dayjs(tx.date).format("DD MMM, YYYY")}</b>
//           </div>
//           <div className="kv" style={{ textAlign: "right" }}>
//             <small>Total Amount</small>
//             <b>{money(tx.amount)}</b>
//           </div>
//         </div>

//         {isPartial && (
//           <div className="txMid3">
//             <div className="kv">
//               <small>Paid</small>
//               <b>{money(tx.paidAmount)}</b>
//             </div>
//             <div className="kv" style={{ textAlign: "right" }}>
//               <small>Remaining</small>
//               <b>{money(tx.remainingAmount)}</b>
//             </div>
//           </div>
//         )}

//         <div className="noteRow" title={note}>
//           <NotesOutlinedIcon style={{ fontSize: 18 }} />
//           <div className="noteText">{note}</div>
//         </div>

//         <div className="txFooter">
//           <div className="txActions">
//             <button className="iconBtn" onClick={() => onEdit(tx)} title="Edit">
//               <EditOutlinedIcon style={{ fontSize: 18 }} />
//             </button>
//             <button className="iconBtn iconBtn--danger" onClick={() => onDelete(tx)} title="Delete">
//               <DeleteOutlineIcon style={{ fontSize: 18 }} />
//             </button>
//           </div>

//           <div className="txOpenBtn" onClick={() => onEdit(tx)} title="Quick edit">
//             Quick Edit
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
import dayjs from "dayjs";
import "./Transactions.css";
import convertToWords from '../../utils/covertToWords'
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import NotesOutlinedIcon from "@mui/icons-material/NotesOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import LocalAtmOutlinedIcon from "@mui/icons-material/LocalAtmOutlined";
import formateToPkr from '../../utils/formatAmount'

const money = (n) => Number(n || 0).toLocaleString();

const methodLabel = (m) => {
  const map = {
    cash: "Cash",
    online: "Online",
    cheque: "Cheque",
    bank_transfer: "Bank Transfer",
    card: "Card",
    other: "Other",
  };
  return map[m] || "Cash";
};

export default function TransactionCard({ tx, onEdit, onDelete }) {
  const isPartial = tx.paymentType === "partial";
  const typeClass = isPartial ? "txType txType--partial" : "txType txType--full";
  const note = tx.description || "No description";

  const pm = methodLabel(tx.paymentMethod);
  const qty = tx.quantity !== undefined && tx.quantity !== null && tx.quantity !== "" ? Number(tx.quantity) : null;

  return (
    <div className="txCard">
      <div className="txCardBody">
        <div className="txTop">
          <div className="txBadge">
            <PaidOutlinedIcon style={{ fontSize: 18 }} />
          </div>

          <div style={{ minWidth: 0 }}>
            <div className="txTitle2" title={tx.title}>{tx.title}</div>
            <div className="txReceiver" title={tx.receiverName}>{tx.receiverName}</div>

            {/* ✅ NEW: meta pills */}
            <div className="txMetaRow">
              <span className="txMetaPill" title="Payment method">
                <LocalAtmOutlinedIcon style={{ fontSize: 16 }} />
                {pm}
              </span>

              {qty !== null && !Number.isNaN(qty) && (
                <span className="txMetaPill txMetaPill--qty" title="Quantity">
                  Qty: {qty}
                </span>
              )}
            </div>
          </div>

          <div className={typeClass}>{isPartial ? "Partial" : "Full"}</div>
        </div>

        <div className="txMid">
          <div className="kv">
            <small>Date</small>
            <b>{dayjs(tx.date).format("DD MMM, YYYY")}</b>
          </div>
          <div className="kv" style={{ textAlign: "right" }}>
            <small>Total Amount</small>
            {/* <b>{money(tx.amount)}<small className="amt-words" >{convertToWords(tx?.amount)}</small></b> */}
            <b  >{money(tx.amount)}</b>
          </div>
<small className="amt-words" >{formateToPkr(tx?.amount)}</small>
        </div>
  

        {isPartial && (
          <div className="txMid3">
            <div className="kv">
              <small>Paid</small>
              <b>{money(tx.paidAmount)}</b>
            </div>
            <div className="kv" style={{ textAlign: "right" }}>
              <small>Remaining</small>
              <b>{money(tx.remainingAmount)}</b>
            </div>
          </div>
        )}

        <div className="noteRow" title={note}>
          <NotesOutlinedIcon style={{ fontSize: 18 }} />
          <div className="noteText">{note}</div>
        </div>

        <div className="txFooter">
          <div className="txActions">
            <button className="iconBtn" onClick={() => onEdit(tx)} title="Edit">
              <EditOutlinedIcon style={{ fontSize: 18 }} />
            </button>
            <button className="iconBtn iconBtn--danger" onClick={() => onDelete(tx)} title="Delete">
              <DeleteOutlineIcon style={{ fontSize: 18 }} />
            </button>
          </div>

          <div className="txOpenBtn" onClick={() => onEdit(tx)} title="Quick edit">
            Quick Edit
          </div>
        </div>
      </div>
    </div>
  );
}
